/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useMemo } from 'react';

export function PdfViewer({ content }: { content?: string }) {
  const pdfUrl = useMemo(() => {
    if (!content) return '';
    const bytes = new Uint8Array(content.length);
    for (let i = 0; i < content.length; i++) bytes[i] = content.charCodeAt(i);
    const blob = new Blob([bytes], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  }, [content]);

  return <iframe src={pdfUrl} style={{ width: '100%', height: '100vh', border: 'none' }} title="PDF Viewer" />;
}
